<script lang="ts" setup>
  import useMarkdown from '~/composables/Markdown/Markdown'
  import {
    ContentBlockIntroductionData,
    ContentBlockTypeId,
  } from '~/model/ContentBlockData/ContentBlockData'
  import useBem from '~/composables/Bem/Bem'
  import { UseBemProps } from '~/composables/Bem/BemFacetOptions'

  interface Props extends UseBemProps, ContentBlockIntroductionData {
    type: ContentBlockTypeId
    facets?: Array<string>
    introduction: string
  }

  const props = defineProps<Props>()
  const { bemAdd, bemFacets } = useBem('c-content-block-introduction', props, {})
  const { parseMarkdown } = useMarkdown()
</script>

<template>
  <div
    :class="bemFacets"
    class="c-content-block-introduction u-markdown-root"
    v-html="parseMarkdown(introduction)"
  />
</template>

<style lang="scss" scoped>
  //
</style>

<style lang="scss">
  @use '/assets/scss/base/typography/typography' as type;

  .c-content-block-introduction {
    grid-column: 3 / 11;

    &.u-markdown-root.u-markdown-root > p {
      @include type.copy-large;
    }
  }
</style>
